module.exports = __webpack_public_path__ + "static/media/image-placeholder.015abc8e.jpg";